import "./styles.scss";

const FilterTitle = ({ title }: { title: string }) => {
  return <h2 className="filter-title">{title}</h2>;
};

export default FilterTitle;
